module.exports = __webpack_public_path__ + "img/ball-blue.fbae6138.png";